import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'styleVibe'

const OPTIONS = [
  {
    value: 'Modern & clean',
    translationKey: 'pages.onboarding.styleVibe.options.modern',
    subtextKey: 'pages.onboarding.styleVibe.subtexts.modern',
    emoji: '🖤',
  },
  {
    value: 'Cozy & warm',
    translationKey: 'pages.onboarding.styleVibe.options.cozy',
    subtextKey: 'pages.onboarding.styleVibe.subtexts.cozy',
    emoji: '☕',
  },
  {
    value: 'Minimalist',
    translationKey: 'pages.onboarding.styleVibe.options.minimalist',
    subtextKey: 'pages.onboarding.styleVibe.subtexts.minimalist',
    emoji: '🤍',
  },
  {
    value: 'Eclectic',
    translationKey: 'pages.onboarding.styleVibe.options.eclectic',
    subtextKey: 'pages.onboarding.styleVibe.subtexts.eclectic',
    emoji: '🎭',
  },
  {
    value: 'Not sure yet',
    translationKey: 'pages.onboarding.styleVibe.options.notSure',
    subtextKey: 'pages.onboarding.styleVibe.subtexts.notSure',
    emoji: '🤔',
  },
]

export default function StyleVibePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    // Find the selected option to get both value and subtext
    const selectedOption = OPTIONS.find((option) => option.value === value)
    const emoji = selectedOption ? selectedOption.emoji : ''

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your style vibe?",
      answer_key: value,
      answer: `${emoji} , ${t(selectedOption?.translationKey ?? '')}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.styleVibe.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
